import { useMemo } from 'react';
import { formatLongDate } from '../../../utils/articleUtils';

export const useArticleMetadata = ({ frontmatter, readingTime, slug, status }) => {
  const baseUrl = useMemo(() => {
    return (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  }, []);

  const title =
    frontmatter.title || (status === 'error' ? 'Artigo nao encontrado' : 'Carregando artigo');
  const summary = frontmatter.summary || '';
  const author = frontmatter.author || 'Guilherme Portella';
  const publishedAt = frontmatter.publishedAt || frontmatter.publishedDate || '';

  const tags = useMemo(() => {
    if (Array.isArray(frontmatter.tags)) {
      return frontmatter.tags;
    }
    if (typeof frontmatter.tags === 'string') {
      return [frontmatter.tags];
    }
    return [];
  }, [frontmatter.tags]);

  const keywords = useMemo(() => {
    if (Array.isArray(frontmatter.keywords)) {
      return frontmatter.keywords;
    }
    if (typeof frontmatter.keywords === 'string') {
      return [frontmatter.keywords];
    }
    return tags;
  }, [frontmatter.keywords, tags]);

  const seoBlock =
    frontmatter.seo && typeof frontmatter.seo === 'object' && !Array.isArray(frontmatter.seo)
      ? frontmatter.seo
      : {};

  const jsonLdOverride =
    frontmatter.jsonLd &&
    typeof frontmatter.jsonLd === 'object' &&
    !Array.isArray(frontmatter.jsonLd)
      ? frontmatter.jsonLd
      : null;

  const seoTitle = frontmatter.seoTitle || seoBlock.title || title;
  const seoDescription = frontmatter.seoDescription || seoBlock.description || summary || '';
  const seoLocale = frontmatter.locale || seoBlock.locale || 'pt-BR';
  const seoImage = frontmatter.ogImage || frontmatter.image || seoBlock.image || '';

  const canonicalUrl = useMemo(() => {
    if (frontmatter.canonicalUrl) {
      return frontmatter.canonicalUrl;
    }
    if (seoBlock.canonicalUrl) {
      return seoBlock.canonicalUrl;
    }
    if (typeof window === 'undefined' || !slug) {
      return '';
    }
    return `${window.location.origin}${baseUrl}/blog/artigos/${slug}`;
  }, [baseUrl, frontmatter.canonicalUrl, seoBlock.canonicalUrl, slug]);

  const minutes = readingTime;
  const dateLabel = formatLongDate(publishedAt);

  return {
    author,
    canonicalUrl,
    dateLabel,
    jsonLdOverride,
    keywords,
    minutes,
    publishedAt,
    seoDescription,
    seoImage,
    seoLocale,
    seoTitle,
    summary,
    tags,
    title,
  };
};
